// ADR-109: one toast for every saved operation, naming the record ("Invoice SAL-000016 recorded"). Lives above the
// routes so it survives the move back to the list; lets touches through; replaced by the next one.
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Toast } from '../design/kit';
import { onCommand, recordOf } from '../lib/ux/feedback';

const SHOW_MS = 3000;

export function ToastHost() {
  const { t } = useTranslation();
  const [toast, setToast] = useState<{ id: number; text: string } | null>(null);
  useEffect(
    () =>
      onCommand((o) => {
        if (!o.ok) return;
        const n = recordOf(o.result);
        const keys = [`toast.${o.operation}`, n ? 'toast.recorded' : 'toast.saved'];
        setToast({ id: Date.now(), text: t(keys, { n }) });
      }),
    [t],
  );
  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), SHOW_MS);
    return () => clearTimeout(timer);
  }, [toast]);
  return (
    <div className="yv-toast-host" data-testid="toast-host">
      {toast && <Toast key={toast.id}>{toast.text}</Toast>}
    </div>
  );
}
